export default __webpack_public_path__ + "static/media/barcode.icon.02226812.svg";